import z from "zod";
import {
  environmentsId,
  localeEnum,
  projectsId,
  templateContentsId,
  templatesId,
  templatesInitializer,
} from "../../db_gen";
import { TEMPLATE_TYPES } from "../../enums";
import { zodName, zodSlug } from "../../utils";

const templateStartDraftSchema = z.object({
  name: zodName(),
  description: templatesInitializer.shape.description,
  type: z.enum(TEMPLATE_TYPES),
  locales: z.array(localeEnum),
});

export type TemplateStartDraftSchema = z.infer<typeof templateStartDraftSchema>;

export default {
  environments: {
    syncEnvironmentVersions: z.object({
      templateId: templatesId,
      activeEnvironmentContents: z.array(
        z.object({
          envId: environmentsId,
          contentId: templateContentsId,
        }),
      ),
    }),
  },
  drafts: {
    getAll: z.object({
      projectId: projectsId.optional(),
    }),
    get: z.object({
      templateSlug: zodSlug(),
      projectId: projectsId,
    }),
    create: z.object({
      templateId: templatesId,
    }),
    delete: z.object({
      draftContentId: templateContentsId,
    }),
    update: z.object({
      draftContentId: templateContentsId,
      newContent: z.object({
        content: z.string(),
        metadata: z.record(z.unknown()).optional(),
      }),
      newSchemaDefinition: z.record(z.unknown()),
    }),
    publish: z.object({
      draftId: templateContentsId,
      changeType: z.enum(["minor", "patch"]),
      environmentIds: z.array(environmentsId),
    }),
  },
  templates: {
    createNew: z.object({
      projectId: projectsId,
      data: templateStartDraftSchema,
    }),
    getAllPublished: z.object({
      projectId: projectsId,
      environmentId: environmentsId.optional(),
    }),
    publishNew: z.object({
      draftTemplateId: templatesId,
    }),
    getPublishedTemplate: z.object({
      projectId: projectsId,
      environmentSlug: zodSlug(),
      templateSlug: zodSlug(),
    }),
  },
};
